import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

const listRouteComponentToHide = [
  "/enter-mobile-for-login",
  "/login-with-mobile",
  "/login",
  "/forget-password",
  "/reset-password",
  "/logout",
  "/register",
  "/come-back-from-google",
];

const ComponentToHide = (props) => {
  const { location } = props;

  if (listRouteComponentToHide.includes(location.pathname)) {
    return null;
  }

  return <Footer />;
};

function Footer() {
  return (
    <footer className="main-footer text-center">
      <p className="m-0">
        ۱۴۰۲ - کلیه حقوق متعلق به شرکت فن آوای هوش مصنوعی است.
      </p>
    </footer>
  );
}

const ComponentThatHides = withRouter(ComponentToHide);
export default ComponentThatHides;
